import { render, staticRenderFns } from "./index.vue?vue&type=template&id=16e8d78d&scoped=true"
import script from "./index.vue?vue&type=script&lang=js"
export * from "./index.vue?vue&type=script&lang=js"
import style0 from "./index.vue?vue&type=style&index=0&id=16e8d78d&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "16e8d78d",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/drone/src/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('16e8d78d')) {
      api.createRecord('16e8d78d', component.options)
    } else {
      api.reload('16e8d78d', component.options)
    }
    module.hot.accept("./index.vue?vue&type=template&id=16e8d78d&scoped=true", function () {
      api.rerender('16e8d78d', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/Advantages2/index.vue"
export default component.exports